import { useEffect } from "react";
import "./LiveStream.module.css";
import Header from "@/reusable_sections/Header";
import VideoGallery from "./sections/VideoGallery";
import Sponsors from "./sections/Sponsors";
import Footer from "@/reusable_sections/Footer";
import HappensSection from "./sections/HappensSection";
import WPStreamPlayer from "./sections/WPStreamPlayer";
export default function LiveStreamPage() {
  useEffect(() => {
    const metaNoCache = document.createElement('meta');
    metaNoCache.httpEquiv = 'Cache-Control';
    metaNoCache.content = 'no-cache, no-store, must-revalidate';
    const metaPragma = document.createElement('meta');
    metaPragma.httpEquiv = 'Pragma';
    metaPragma.content = 'no-cache';
    const metaExpires = document.createElement('meta');
    metaExpires.httpEquiv = 'Expires';
    metaExpires.content = '0';
    document.head.appendChild(metaNoCache);
    document.head.appendChild(metaPragma);
    document.head.appendChild(metaExpires);
    return () => {
      document.head.removeChild(metaNoCache);
      document.head.removeChild(metaPragma);
      document.head.removeChild(metaExpires);
    };
  }, []);
  return <div>
      <Header />
      <VideoGallery />
      <Sponsors />
      <HappensSection />
      {}
      <div data-cache="no-cache" data-10web-exclude="true">
        <WPStreamPlayer />
      </div>
      {}
      
      <Footer />
    </div>;
}